export default __webpack_public_path__ + "static/media/interface-3.e90ca5b4.png";